exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-slide[data-v-df8803a6] {\n  text-align: center !important;\n}\n.swiper-container[data-v-df8803a6] {\n  margin-top: 20px !important;\n}\n.nav-icon-links[data-v-df8803a6] {\n  border-radius: 16px;\n}\n.nav-icon-links .nav-title[data-v-df8803a6] {\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 60px;\n  margin: 0 auto;\n  color: #383838;\n  font-weight: 500;\n}", ""]);

// exports
